import React from 'react';
import { useTranslation } from "react-i18next";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Spinner } from 'reactstrap';

function CompLoaderBtn() {

    return (
        <React.Fragment>
            <span><i className="fa fa-spinner fa-spin"></i> </span>
        </React.Fragment>
    );
}
export default CompLoaderBtn;